/** @jsx jsx */
/**
 *
 * FreshPets Instagram Grid
 *
 */
import firebase from 'gatsby-plugin-firebase'
import { useEffect, useState } from 'react'
import { Alert, Box, Card, Container, Flex, jsx, Spinner } from 'theme-ui'
import InstagramGridItem from './instagram-grid-item'

const InstagramGrid = ({ slice = 0 }) => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [data, setData] = useState([])

    useEffect(() => {
        const fetchInstagramPosts = async () => {
            console.log('🔥 Calling Firebase Cloud Functions 🔥')

            const getInstagramPosts = firebase
                .functions()
                .httpsCallable('getInstagramPosts')

            try {
                const { data: posts } = await getInstagramPosts()
                // console.log('🦄: fetchInstagramPosts -> posts', { posts })

                // Bail early if error retrieving posts
                if (posts === false) {
                    setError(true)
                    return
                }
                setData(slice ? posts.slice(0, slice) : posts)
            } catch (error) {
                console.error(error)
            } finally {
                setLoading(false)
            }
        }

        fetchInstagramPosts()
    }, [slice])

    return (
        <Container>
            {loading && (
                <Flex
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                    <Spinner />
                </Flex>
            )}
            {error && (
                <Flex
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                    <Alert>Error fetching posts</Alert>
                </Flex>
        )}
            <Flex sx={{ flexWrap: 'wrap', px: [0, -3], my: 3 }}>
                {data.map(post => (
                    <Box key={post.id} sx={{ width: ['100%', '33.3%'], px: 3 }}>
                        <Card>
                            <InstagramGridItem post={post} />
                        </Card>
                    </Box>
                ))}
            </Flex>
        </Container>
    )
}

export default InstagramGrid
